// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"271":"bonos-regalo","669":"ok","757":"ko","779":"error"}[chunkId] + "." + {"271":"02cc9f31","669":"da129200","757":"2a1904e4","779":"5e58c0a2"}[chunkId] + ".css";
};